import { useEffect } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../../automotive/AdminAutomotiveNav";
import { AdminDealerNav } from "../dealerAdminShared";
import { trackFoundingDealerEvent } from "../../../../constants/automapFoundingDealerConstants";

export function AdminFoundingNav({ active = "dashboard" }) {
  const items = [
    { key: "dashboard", label: "Resumen", href: "/admin/dealers/founding" },
    { key: "pipeline", label: "Pipeline", href: "/admin/dealers/founding/pipeline" },
    { key: "readiness", label: "Readiness", href: "/admin/dealers/founding/readiness" },
    { key: "imports", label: "Importaciones", href: "/admin/dealers/founding/imports" },
    { key: "tasks", label: "Tareas", href: "/admin/dealers/founding/tasks" },
  ];
  return (
    <nav className="admin-console__nav-tabs admin-founding-nav">
      {items.map((item) => (
        <Link key={item.key} to={item.href} className={active === item.key ? "is-active" : undefined}>
          {item.label}
        </Link>
      ))}
    </nav>
  );
}

export function FoundingShell({ active, title, description, viewEvent, children }) {
  useEffect(() => {
    if (viewEvent) trackFoundingDealerEvent(viewEvent);
  }, [viewEvent]);

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Dealers fundadores" title={title} description={description} />
      <AdminAutomotiveNav active="dealers" />
      <AdminDealerNav active="founding" />
      <AdminFoundingNav active={active} />
      <main className="admin-console__main wrap">{children}</main>
    </AdminPageLayout>
  );
}

export function CopyTemplateButton({ label, text }) {
  const copy = () => {
    navigator.clipboard?.writeText(text);
  };
  const openWa = () => {
    copy();
  };
  return (
    <div className="dealer-state-box">
      <strong>{label}</strong>
      <p className="muted" style={{ whiteSpace: "pre-wrap" }}>{text}</p>
      <button type="button" className="dealer-portal-btn" onClick={copy}>
        Copiar mensaje
      </button>
    </div>
  );
}
